import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateTrackerCountryResponse } from '../types';
import {
  AFFILIATE_GET_TRACKER_COUNTRY_API_URL,
  AFFILIATE_GET_TRACKER_COUNTRY_QUERY,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useAffiliateTrackerCountryQuery(
  id: Ref<number | undefined>,
  trackerId: Ref<number | undefined>,
  enabled: Ref<boolean | undefined>,
): IContextQueryResult<IAffiliateTrackerCountryResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateTrackerCountryResponse>({
    queryKey: [AFFILIATE_GET_TRACKER_COUNTRY_QUERY, id, trackerId],
    queryFn: ({ signal }) => fetchGet<IAffiliateTrackerCountryResponse>(
      AFFILIATE_GET_TRACKER_COUNTRY_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.UPDATE_COUNTRY,
        urlParams: {
          id: id.value,
          trackerId: trackerId.value,
        },
      },
    ),
    enabled: computed(() => !!enabled.value && !!id.value && !!trackerId.value),
  });
}
